import apiUrl from 'helpers/apiUrl';
import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';

export const getBannersRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/banners`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

export const getSpecificBannerRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/banners/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const updateSpecificBannerRequest = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/banners/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      if (data) {
        message.success('Pozytywnie zapisano');
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};
